import { useParams } from 'react-router-dom';
import { usePools } from '../DatabaseContext';
import React, { useEffect, useState } from 'react';
import ChoiceQuestion from '../Fields/ChoiceQuestion';
import FormContainer from '../Fields/FormContainer';
import SaveAndContinue from '../Fields/SaveAndContinue';
import BubbleLoader from '../../../Libraries/Loader/bubble-loader';
import TextQuestion from '../Fields/TextQuestion';

export default function PowerPage({ i18n }) {
    const { id } = useParams()
    const { setPoolId, pool } = usePools()
    const [powerSupply, setPowerSupply] = useState('')
    const [spend, setSpend] = useState('')

    const updateFields = () => {
        setPowerSupply(pool?.power_supply)
        setSpend(pool?.power_spend || '')
    }

    const notReady = () => {
        return !(
            id &&
            pool &&
            powerSupply !== undefined &&
            spend !== undefined
        );
    }

    useEffect(() => {
        setPoolId(id)
    }, [id])

    useEffect(() => {
        updateFields();
    }, [pool])

    if (notReady()) {
        return <BubbleLoader />
    }

    return <FormContainer breadcrumb={[
        { label: pool.name, url: `/${pool.id}/name` },
        { label: i18n.dimensions.heading, url: `/${pool.id}/dimensions` },
        { label: i18n.temperature.heading, url: `/${pool.id}/temperature` },
        { label: i18n.location.heading, url: `/${pool.id}/location` },
        { label: i18n.seasons.heading, url: `/${pool.id}/seasons` },
        { label: i18n.power.heading },
    ]} >

        <ChoiceQuestion
            label={ i18n.power.label }
            name="power_supply"
            onChange={ setPowerSupply }
            value={ powerSupply }
            options={[
                { label: i18n.power.singlePhase, value: 'Single phase' },
                { label: i18n.power.threePhase, value: 'Three phase' },
                { label: i18n.power.both, value: 'Both' },
            ]}
        />

        <div className="mt-8">
            <TextQuestion
                value={ spend }
                onChange={ setSpend }
                name="power_spend"
                label={ i18n.power.spend }
                small={ true }
            />
        </div>

        <SaveAndContinue text={ i18n.forms.saveReview } id={ pool?.id } data={{
            power_supply: powerSupply,
            power_spend: spend,
        }} next="summary" />

    </FormContainer>
}
